export { default } from './Statistics'
export * from './Statistics'



// WEBPACK FOOTER //
// ./src/components/Statistics/index.ts